"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var WebApplicationConfigurationEntity_1 = __importDefault(require("./Entity/WebApplicationConfigurationEntity"));
var WebApplicationConfigurationApi = /** @class */ (function () {
    function WebApplicationConfigurationApi(session) {
        this.webApplicationConfigurationEntity = new WebApplicationConfigurationEntity_1.default(session);
    }
    WebApplicationConfigurationApi.prototype.get = function () {
        return this.webApplicationConfigurationEntity.get();
    };
    return WebApplicationConfigurationApi;
}());
exports.default = WebApplicationConfigurationApi;
//# sourceMappingURL=WebApplicationConfigurationApi.js.map